import { useState } from 'react';
import { createPortal } from 'react-dom';
import { BlenderAddonModal } from './BlenderAddonModal';
import { navClass } from '../../components/TabbedSidebarLayout';
import { useLanguage } from '../../contexts/LanguageContext';

// The way out to a real Blender: the add-on's installer, its key, and which .blend files this
// notice has — one dialog about one subject, so one button.
//
// AT THE BOTTOM OF THE SIDEBAR, and only there (see DocSidebar). It was under the meshes, where
// it read as a control of the part on screen; the add-on belongs to the account, not to a part
// or a phase, so it sits with the rail's other things that are not the page's navigation.
export function BlenderAddonButton({ docId }: { docId: string }) {
  const { t } = useLanguage();
  const [setup, setSetup] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setSetup(true)}
        className={`w-full justify-center ${navClass(false, 'text-xs')}`}
      >
        {t('notice.addon.button')}
      </button>
      {/* ON THE BODY: the sidebar is its own stacking context, and a fixed overlay drawn inside
          it was clipped to the rail and sat under the page's viewer. */}
      {setup && createPortal(
        <BlenderAddonModal docId={docId} onClose={() => setSetup(false)} />,
        document.body,
      )}
    </>
  );
}
